export default "__VITE_ASSET__BWXsAgIO__"